import { render } from "./ModalSearchBar.vue?vue&type=template&id=4230e6a2&ts=true"
import script from "./ModalSearchBar.vue?vue&type=script&lang=ts"
export * from "./ModalSearchBar.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__